/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('CureCtrl', ["$scope", "$dialog", "$timeout", "CureCategorySrv", "CureCategoryData", "CureCategory", "CureSrv",
        "CureData", "Cure", "ImageData", "CureView", "CureCategoryView", "StyleData", "CompanyImageData","CategoryView","CategoryData","CompanyImageSrv", "LanguageManager",
        function($scope,$dialog,$timeout,CureCategorySrv,CureCategoryData,CureCategory,CureSrv,
         CureData,Cure,ImageData,CureView,CureCategoryView,StyleData,CompanyImageData,CategoryView,CategoryData,CompanyImageSrv, LanguageManager)
{
    $scope.dd =
    {
        view : 
        {
            categoryRootView : null,
            curesViewIndex : [],//Keep index
            deletedCategoriesView : [],
            serviceCategoryRootView : null,
            cServiceCategoryView : null,
            deletedCuresView : [],
            imagesView : [],
            imagesViewFiltered : [],
            styles : StyleData.styles,
            displaySubConf : 1,
            tab : 1,
            subTab:1,
            displayError : false,  //Used  to display error message when user click on save,
            selected : {
                categoryView : null,
                cureView : null
            },
            edited :
            {
                categoryView : null,
                cureView : null
            }
        },
        flowConfig : {
            target: '/rest/companyImageUpload',
            method:'octet',
            query : {companyCode: $scope.ad.companyCode,type:'cure'},
            maxChunkRetries: 1,
            chunkRetryInterval: 5000,
            simultaneousUploads: 4,
            singleFile: true,
            testChunks:false,
            headers: {Authorization: $scope.ad.currentUser.token}
        }
    };

    $scope.$watch('ad.dataLoaded', function(newValue, oldValue) {
        if (newValue) {
            if (!$scope.ad.managerMode) {
                $scope.goToDomain("planningPos", "dashboard");
            }
            $scope.dd.view.serviceCategoryRootView = new CategoryView(CategoryData.categoryRoot,CategoryData.getIndexOf(CategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
            $scope.dd.view.cServiceCategoryView =  $scope.dd.view.serviceCategoryRootView;
            $scope.dd.view.imagesView = ImageData.getActiveList("");
            $scope.dd.view.imagesViewFiltered = ImageData.getFilteredImages();
            $scope.dd.view.categoryRootView = new CureCategoryView(CureCategoryData.categoryRoot,CureCategoryData.getIndexOf(CureCategoryData.categoryRoot),null,$scope);// categoryRoot index  = 0
            $scope.dd.view.categoryRootView.label = "Racine";
            $scope.dd.view.selected.categoryView = $scope.dd.view.categoryRootView;

            var categories = CureCategoryData.getDeletedList();
            var parentCatView;
            for (var i=0;i<categories.length;i++)
            {
                if (categories[i].parentCategory)
                    parentCatView =  $scope.getCategoryView(categories[i].parentCategory);
                else
                    parentCatView =null;
                $scope.dd.view.deletedCategoriesView.push(new CureCategoryView(categories[i],CureCategoryData.getIndexOf(categories[i]),parentCatView,$scope))
            }
            var cures = CureData.getDeletedList();
            for (var i=0;i<cures.length;i++)
            {
                if (cures[i].parentCategory)
                    parentCatView =  $scope.getCategoryView(cures[i].parentCategory);
                else
                    parentCatView =null;
                $scope.dd.view.deletedCuresView.push(new CureView(cures[i],CureData.getIndexOf(cures[i]),parentCatView,$scope))
            }
        }
    });

    $scope.addCureViewIndex  = function(cureView)
    {
        $scope.dd.view.curesViewIndex.push(cureView);
    };

    $scope.getCfgClass   = function(confItem,className)
    {
        if (confItem==$scope.dd.view.displaySubConf)
            return className;
        return "";
    };

    $scope.getServiceView = function (service)
    {
        return $scope.dd.view.serviceCategoryRootView.getServiceView(service)
    }
//CATEGORY


    $scope.getCategoryView = function (category)
    {
        //Assume view index = model index
        var categoryView = $scope.dd.view.categoryRootView.getCategoryView(category)
        if (!categoryView) //must be deleted then instanciate it
        {
            var parentCategoryView = null;
            if (category.parentCategory)
                parentCategoryView = this.getCategoryView(category.parentCategory)
            categoryView =  new CureCategoryView(category,CureCategoryData.getIndexOf(category),parentCategoryView,this);

        }
        return categoryView;
    };
    $scope.createCategory  = function(parentCategoryView)
    {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.cureView)
            if ($scope.dd.view.edited.cureView.isChanged())
            {
                $scope.displayChangeMsg = true;
                return;
            }
            else
            {
                $scope.dd.view.edited.cureView.hrSkillsView = null;
                $scope.dd.view.edited.cureView.prSkillsView = null;
                $scope.dd.view.edited.cureView = null;
            }

        var categoryView = new CureCategoryView(null,-1,parentCategoryView,$scope);
        if (parentCategoryView)
        {
            if(parentCategoryView.image)
                categoryView.setImage(parentCategoryView.image);

            $scope.dd.view.edited.categoryView = categoryView;
            parentCategoryView.addCategoryView(categoryView);
        }
    };
    $scope.setCurrentCategory  = function(category)
    {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.cureView)
            if ($scope.dd.view.edited.cureView.isChanged())
            {
                $scope.displayChangeMsg = true;
                return;
            }
            else
            {
                $scope.dd.view.edited.cureView.hrSkillsView = null;
                $scope.dd.view.edited.cureView.prSkillsView = null;
                $scope.dd.view.edited.cureView = null;
            }

        if($scope.dd.view.edited.categoryView)
            $scope.dd.view.edited.categoryView = null;

        $scope.dd.view.selected.categoryView = category;
    };
    $scope.setEditedCategory  = function(categoryView)
    {
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        if ($scope.dd.view.edited.cureView)
            if ($scope.dd.view.edited.cureView.isChanged())
            {
                $scope.displayChangeMsg = true;
                return;
            }
            else
            {
                $scope.dd.view.edited.cureView.hrSkillsView = null;
                $scope.dd.view.edited.cureView.prSkillsView = null;
                $scope.dd.view.edited.cureView = null;
            }

        $scope.dd.view.edited.categoryView = categoryView;

        if ($scope.dd.view.tab>2)
            $scope.dd.view.tab =1;
    };
    $scope.saveEditedCategory  = function()
    {
        if ($scope.dd.view.edited.categoryView)
            $scope.dd.view.edited.categoryView.updateModel();
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.cancelEditedCategory   = function()
    {
        $scope.dd.view.edited.categoryView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.categoryView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.afterRemoveCategory  = function(category)
    {
        if (!category.parentCategory)//Remove from $scope
        {
            var index = $scope.categoryRoot.categories.indexOf(category);
            if (index!=-1)
                $scope.categoryRoot.categories.splice(index,1);
            $scope.currentCategory = null;
        }
    };
    $scope.openDeletedCategoryViewConfirmDialog  = function()
    {
        if ($scope.dd.view.edited.categoryView)
        {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl:  '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl' ,
                resolve: {
                    dialogsModel: function() {
                        var tableModel = [] ;
                        tableModel["label"] = $scope.dd.view.edited.categoryView.label;
                        return tableModel;
                    }}};

            var d = $dialog.dialog(opts);
            d.open().then(function(result){
                if (result)
                    $scope.removeEditedCategory();
            });
        }
    };
    $scope.removeEditedCategory  = function()
    {
        if ($scope.dd.view.edited.categoryView)
        {
            $scope.dd.view.edited.categoryView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.categoryView.parentCategoryView;
            if (parentCategoryView)
                parentCategoryView.removeCategoryView($scope.dd.view.edited.categoryView);
            $scope.dd.view.deletedCategoriesView.push($scope.dd.view.edited.categoryView);
            $scope.dd.view.edited.categoryView = null;
            $scope.displayChangeMsg = false;
        }

    };
    $scope.getClassForActiveCategory = function(category,className)
    {
        ////console.log("getClassForActive" + cure.id);
        if (category === $scope.dd.view.edited.categoryView)
            return className;
        return "";
    };
    $scope.restoreCategory  = function(categoryView)
    {
        if (categoryView)
        {
            if (categoryView.catIndex!=-1)// retrieve old value from server
                categoryView.restoreModel();
            var index = $scope.dd.view.deletedCategoriesView.indexOf(categoryView);
            if (index!=-1)
            {
                $scope.dd.view.deletedCategoriesView.splice(index,1);
                if (categoryView.parentCategoryView)
                    categoryView.parentCategoryView.addCategoryView(categoryView)
            }


        }

    };


// Cure


    $scope.getClassForActiveCure = function(cure,className)
    {
        ////console.log("getClassForActive" + cure.id);
        if (cure === $scope.dd.view.edited.cureView)
            return className;
        return "";
    };
    $scope.createCure  = function()
    {
        if ($scope.dd.view.edited.categoryView)
            if ($scope.dd.view.edited.categoryView.isChanged()) {
                $scope.displayChangeMsg = true;
                return;
            }
            else
                $scope.dd.view.edited.categoryView = null;

        if ($scope.dd.view.edited.cureView && $scope.dd.view.edited.cureView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        var categoryView = $scope.dd.view.selected.categoryView;
        if (categoryView.catIndex==-1)
        {
            alert("Vous devez sauver une première fois la catégorie pour pouvoir lui ajouter des cures.")
            return;
        }
        var newCureView =   new CureView(null,-1,categoryView,$scope);
        categoryView.addCureView(newCureView);

        if (categoryView.image && categoryView.image !== null)
            newCureView.setImage(categoryView.image);

        $scope.setEditedCure(newCureView);
    };
    $scope.cureClicked = function(cureView) //Function linked to curesSelector.html
    {
        $scope.setEditedCure(cureView);
    };
    $scope.setEditedCure = function(cureView)
    {
        if ($scope.dd.view.edited.categoryView)
            if ($scope.dd.view.edited.categoryView.isChanged())
            {
                $scope.displayChangeMsg = true;
                return;
            }
            else
                $scope.dd.view.edited.categoryView = null;
        if ($scope.dd.view.edited.cureView && $scope.dd.view.edited.cureView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }
        $scope.dd.view.edited.cureView = cureView;
    };
    

    $scope.saveEditedCure = function()
    {
        if ($scope.dd.view.edited.cureView)
        {
            $scope.dd.view.edited.cureView.updateModel();
            $scope.dd.view.displayError = false;
            $scope.dd.view.edited.cureView.hrSkillsView = null;
            $scope.dd.view.edited.cureView.prSkillsView = null;
            $scope.dd.view.edited.cureView = null;
            $scope.displayChangeMsg = false;
        }
    };
    $scope.cancelEditedCure = function()
    {
        $scope.dd.view.edited.cureView.reloadModel();
        $scope.dd.view.displayError = false;
        $scope.dd.view.edited.cureView.hrSkillsView = null;
        $scope.dd.view.edited.cureView.prSkillsView = null;
        $scope.dd.view.edited.cureView = null;
        $scope.displayChangeMsg = false;
    };
    $scope.openDeletedCureViewConfirmDialog = function()
    {
        if ($scope.dd.view.edited.cureView)
        {
            var opts = {
                backdrop: true,
                keyboard: true,
                backdropClick: false,
                templateUrl:  '/partials/global/removeConfirm.html',
                controller: 'DialogCtrl' ,
                resolve: {
                    dialogsModel: function() {
                        var tableModel = [] ;
                        tableModel["label"] = $scope.dd.view.edited.cureView.label;
                        return tableModel;
                    }}};

            var d = $dialog.dialog(opts);
            d.open().then(function(result){
                if (result)
                    $scope.removeEditedCure();
            });
        }
    };
    $scope.removeEditedCure  = function()
    {
        if ($scope.dd.view.edited.cureView)
        {
            $scope.dd.view.edited.cureView.removeModel();
            var parentCategoryView = $scope.dd.view.edited.cureView.parentCategoryView;
            if (parentCategoryView)
                parentCategoryView.removeCureView($scope.dd.view.edited.cureView);
            $scope.dd.view.deletedCuresView.push($scope.dd.view.edited.cureView);
            $scope.dd.view.edited.cureView.hrSkillsView = null;
            $scope.dd.view.edited.cureView.prSkillsView = null;
            $scope.dd.view.edited.cureView = null;

            $scope.displayChangeMsg = false;
        }
    };
    $scope.restoreCure  = function(cureView)
    {
        if (cureView)
        {
            if (cureView.servIndex!=-1)// retrieve old value from server
                cureView.restoreModel();
            var index = $scope.dd.view.deletedCuresView.indexOf(cureView);
            if (index!=-1)
            {
                $scope.dd.view.deletedCuresView.splice(index,1);
                if (cureView.parentCategoryView)
                    cureView.parentCategoryView.addCureView(cureView)
            }


        }

    };


//Assign image


    $scope.imageIsSelected = function(image)
    {
        if ($scope.dd.view.edited.cureView)
        {
            if (!$scope.dd.view.edited.cureView.companyImage && $scope.dd.view.edited.cureView.image===image)
                return true
        }
        else
            if (!$scope.dd.view.edited.categoryView.companyImage && $scope.dd.view.edited.categoryView.image===image)
                return true

        return false;
    };

    $scope.companyImageIsSelected = function(companyImage)
    {
        if ($scope.dd.view.edited.cureView && $scope.dd.view.edited.cureView.companyImage===companyImage)
            return true
        if ($scope.dd.view.edited.categoryView && $scope.dd.view.edited.categoryView.companyImage===companyImage)
            return true
        return false;
    };
    $scope.setImage  = function(image)
    {
        if($scope.dd.view.edited.cureView)
        {
            if(image === $scope.dd.view.edited.cureView.image)
            {
                if($scope.dd.view.edited.cureView.image != null)
                {
                    $scope.dd.view.edited.cureView.setImage(null);
                }
                else
                {
                    $scope.dd.view.edited.cureView.setImage($scope.dd.view.edited.cureView.parentCategoryView.image);
                }
            }
            else if(image != null)
            {
                $scope.dd.view.edited.cureView.setImage(image);
            }
            else
            {
                $scope.dd.view.edited.cureView.setImage($scope.dd.view.edited.cureView.parentCategoryView.image);
            }
        }

        if($scope.dd.view.edited.categoryView)
        {
            if(image === $scope.dd.view.edited.categoryView.image)
            {
                if($scope.dd.view.edited.categoryView.image != null)
                {
                    $scope.dd.view.edited.categoryView.setImage(null);
                }
                else
                {
                    $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
                }
            }
            else if(image != null)
            {
                $scope.dd.view.edited.categoryView.setImage(image);
            }
            else
            {
                $scope.dd.view.edited.categoryView.setImage($scope.dd.view.edited.categoryView.parentCategoryView.image);
            }
        }
    };
    $scope.setCompanyImage  = function(companyImage)
    {
        if($scope.dd.view.edited.cureView)
        {
            if(companyImage === $scope.dd.view.edited.cureView.companyImage)
            {
                if($scope.dd.view.edited.cureView.companyImage != null)
                {
                    $scope.dd.view.edited.cureView.setCompanyImage(null);
                }
                else
                {
                    $scope.dd.view.edited.cureView.setCompanyImage($scope.dd.view.edited.cureView.parentCategoryView.companyImage);
                }
            }
            else if(companyImage != null)
            {
                $scope.dd.view.edited.cureView.setCompanyImage(companyImage);
            }
            else
            {
                $scope.dd.view.edited.cureView.setCompanyImage($scope.dd.view.edited.cureView.parentCategoryView.companyImage);
            }
        }

        if($scope.dd.view.edited.categoryView)
        {
            if(companyImage === $scope.dd.view.edited.categoryView.companyImage)
            {
                if($scope.dd.view.edited.categoryView.companyImage != null)
                {
                    $scope.dd.view.edited.categoryView.setCompanyImage(null);
                }
                else
                {
                    $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
                }
            }
            else if(companyImage != null)
            {
                $scope.dd.view.edited.categoryView.setCompanyImage(companyImage);
            }
            else
            {
                $scope.dd.view.edited.categoryView.setCompanyImage($scope.dd.view.edited.categoryView.parentCategoryView.companyImage);
            }
        }
    };

    $scope.getEditedItem = function(){
        return $scope.dd.view.edited.categoryView ? $scope.dd.view.edited.categoryView : ($scope.dd.view.edited.cureView ? $scope.dd.view.edited.cureView : null);
    };

}]);



// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/cureCtrl.js